
import Vue from 'vue';
import { IMPROVEMENT_OPTIONS } from '@/constants/smallDetails';
import { CvDropdown, CvDropdownItem, CvTextArea } from '@carbon/vue';
import DocumentAttachment16 from '@carbon/icons-vue/es/document--attachment/16';

export default Vue.extend({
  components: {
    CvDropdown,
    CvDropdownItem,
    CvTextArea,
    DocumentAttachment16,
  },
  props: {
    fileName: {
      type: String,
      default: '',
    },
    logoImprovementFormData: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      IMPROVEMENT_OPTIONS,
    };
  },
  computed: {
    getTranslatedImprovementOptions(): string[] {
      return IMPROVEMENT_OPTIONS.map((item) => {
        const [key, value] = Object.entries(item)[0];
        return this.$t(
          `wizard-v2.small-details.improvement-options.${key}`
        ).toString();
      });
    },
  },
  methods: {
    selectImprovementOption(selectedOptionIdx: string): void {
      const selectedOption = IMPROVEMENT_OPTIONS[+selectedOptionIdx];
      const optionKey = Object.keys(selectedOption)[0];

      this.$emit('update-form', {
        ...this.logoImprovementFormData,
        improvementOption: this.$t(
          `wizard-v2.small-details.improvement-options.${optionKey}`
        ).toString(),
        improvementOptionKey: optionKey,
      });
    },
  },
});
